/* Product cards: bundles have no size option, so their third line names the number of products in the bundle.
   The count comes from the Fly Bundles config the app embeds on every page (window.fly_app_data).
   Without that config the line stays hidden. */
(function () {
  function bundleCounts() {
    var data = window.fly_app_data && window.fly_app_data.data;
    var bundles = (data && data.frequentBoughtData) || [];
    var counts = {};
    bundles.forEach(function (bundle) {
      var shopifyData = bundle.bundleShopifyData;
      if (!shopifyData || !shopifyData.id || String(bundle.isActive) === 'false') return;
      var count = (bundle.selectedProducts || []).reduce(function (sum, product) {
        return sum + (parseInt(product.quantity, 10) || 1);
      }, 0);
      if (count > 1) counts[String(shopifyData.id)] = count;
    });
    return counts;
  }

  function apply() {
    var lines = document.querySelectorAll('[data-card-bundle-count][hidden]');
    if (!lines.length) return true;
    if (!window.fly_app_data) return false;
    var counts = bundleCounts();
    Array.prototype.forEach.call(lines, function (line) {
      var count = counts[line.getAttribute('data-card-bundle-count')];
      if (!count) return;
      line.textContent = line.getAttribute('data-label').replace('__N__', count);
      line.hidden = false;
    });
    return true;
  }

  function run() {
    var tries = 0;
    (function attempt() {
      if (apply() || ++tries > 20) return;
      setTimeout(attempt, 300);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // Grids that load later (filters, pagination, theme editor).
  document.addEventListener('shopify:section:load', run);
  if ('MutationObserver' in window) {
    var grid = document.querySelector('.collection-product-grid__products');
    if (grid) new MutationObserver(run).observe(grid, { childList: true });
  }
})();
